import {computed, inject, Injectable} from '@angular/core';
import {OrganizationService} from './organization.service';
import {ToastService} from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private readonly org = inject(OrganizationService);
  private readonly toast = inject(ToastService);

  readonly role = computed(() => this.org.activeOrganization()?.currentUserRole)

  readonly canEdit = computed(() => {
    const role = this.role()
    return role && role !== 'reader'
  })

  constructor() { }

  assertCanEdit(): boolean {
    if (this.canEdit()) return true
    this.accessDenied()
    return false
  }

  assertAdmin(): boolean {
    if (this.role() === 'admin') return true
    this.accessDenied()
    return false
  }

  private accessDenied() {
    this.toast.error('Access Denied', 'You do not have the necessary permissions to do this.')
  }
}
